import { render, staticRenderFns } from "./recovery_list.vue?vue&type=template&id=3504a35e"
import script from "./recovery_list.vue?vue&type=script&lang=js"
export * from "./recovery_list.vue?vue&type=script&lang=js"
import style0 from "./recovery_list.vue?vue&type=style&index=0&id=3504a35e&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JNproject\\qbyfdq-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3504a35e')) {
      api.createRecord('3504a35e', component.options)
    } else {
      api.reload('3504a35e', component.options)
    }
    module.hot.accept("./recovery_list.vue?vue&type=template&id=3504a35e", function () {
      api.rerender('3504a35e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/recovery_list.vue"
export default component.exports